import './PageFooter.scss'
import React from 'react'

export default ({ children }) => (
  <div className="page-footer">
    { children }
  </div>
)
